<h2 class="text-2xl font-bold p-4">Gestisci Operatori</h2>

<app-entity-crud-page-template
  [data]="users"
  [columns]="columns"
  [loading]="loading"
  [totalRecords]="totalRecords"
  [rows]="rows"
  (onLazyLoad)="loadUsers($event)"
  (onCreate)="saveUser()"
  (onDeleteSelected)="deleteSelectedUsers($event)"
  [enableSearch]="false"
  [enableFilterReset]="true"
  [canCreate]="canCreate"
  [topbarTemplate]="onlineCounter"
/>

<ng-template #roleTemplate let-row>
  @if (row.roleId === 1){
    <i class="pi pi-crown text-primary"></i>
  } @else if (row.roleId  === 2){
    <i class="pi pi-check-circle text-primary"></i>
  } @else {
    <i class="pi pi-times-circle text-red-400"></i>
  }
</ng-template>

<ng-template #allowSelfAssignmentTemplate let-row>
  @if ((row.allowSelfAssignment && row.roleId === 3) || (row.roleId === 2)){
    <i class="pi pi-check-circle text-primary"></i>
  } @else {
    <i class="pi pi-times-circle text-red-400"></i>
  }
</ng-template>


<ng-template #onlineTemplate let-row>
    @if (row.status === USER_STATUS.ONLINE){
      <div class="conversation-status-pulse conversation-status-pulse--green" pTooltip="Disponibile" tooltipPosition="top">
        <div class="dot"></div>
        <div class="outline"></div>
      </div>
    } @else if (row.status === USER_STATUS.AWAY){
      <div class="conversation-status-pulse conversation-status-pulse--orange" pTooltip="Assente" tooltipPosition="top">
        <div class="dot"></div>
        <div class="outline"></div>
      </div>
    } @else {
      <div class="conversation-status-pulse conversation-status-pulse--red" pTooltip="Non Disponibile" tooltipPosition="top">
        <div class="dot"></div>
      </div>
    }
</ng-template>


<ng-template #onlineCounter>
  <div class="ms-4 flex items-center justify-center">
    <p-message severity="secondary" size="small" class="text-muted-color">
      <div class="conversation-status-pulse conversation-status-pulse--green">
        <div class="dot"></div>
        <div class="outline"></div>
      </div>
      {{ onlineCount }} Operatori Online
    </p-message>
  </div>
</ng-template>
